export default "__VITE_ASSET__6a84168b__"